import React from 'react';
import { Col, Row } from 'reactstrap';
import { NewsLetterStyle } from '../../../StyledComponents';

const TransactionHistoryDetails = () => {
  const transactionDetails = [
    { label: "Transaction ID:", value: "123456" },
    { label: "Merchant:", value: "Store ABC" },
    { label: "Order Number:", value: "56789 (if applicable)" },
    { label: "Transaction Date:", value: "DD/MM/YYYY" },
    { label: "Transaction Time:", value: "14:30" },
    { label: "Amount Spent:", value: "$20" },
    { label: "Balance After Spent:", value: "$50" },
    { label: "Additional Note:", value: "Any additional notes or details about the transaction." }
  ];

  return (
    <>
      <Row>
        <Col xl='12' lg='12' md='12' sm='12' xs='12'>
          {transactionDetails.map((detail, index) => (
            <Row key={index} style={{ marginBottom: '0.5rem', }}>
              <Col xl='4' lg='4' md='4' sm='12' xs='12' style={{ fontWeight: 'bold' }}>
                {detail.label}
              </Col>
              <Col xl='8' lg='8' md='8' sm='12' xs='12'>
                {detail.value}
              </Col>
            </Row>
          ))}
        </Col>
      </Row>
    </>
  );
};

export default TransactionHistoryDetails;
